import React from 'react';
import { ModuleName } from '@web/core/navigation/module-name';
import NoMatch from '@web/views/no-match';
import { CampaignsList } from './components/campaigns-list';

export type CampaignsRoute = { path?: string; index?: boolean; element: React.ReactNode; moduleName?: ModuleName };

export const campaignsRoutes: CampaignsRoute[] = [
    { index: true, element: <CampaignsList />, moduleName: ModuleName.Campaigns },
    { path: '*', element: <NoMatch /> },
];
